import React from 'react';
import CostcoLocationTemplate from '../../components/CostcoLocationTemplate';

const Kilburn = () => (
  <CostcoLocationTemplate
    warehouseName="Adelaide"
    suburb="Kilburn"
    state="South Australia"
    stateShort="SA"
    address="Churchill Rd, Kilburn SA 5084"
    path="/costco/adelaide"
    nearbySuburbs={[
      'Kilburn',
      'Prospect',
      'Enfield',
      'Blair Athol',
      'Clearview',
      'Northgate',
      'Gepps Cross',
      'Mawson Lakes',
      'Pooraka',
      'Nailsworth',
    ]}
    description="Manage Your Loans is the exclusive Costco member loan partner serving the Adelaide warehouse in Kilburn and Adelaide's northern suburbs. Whether you're a first home buyer taking advantage of South Australia's affordable market, refinancing your existing home loan, or investing in the growing northern corridor, our brokers can help you earn Costco Shop Card rewards on settled loans."
    localContext={[
      'Adelaide remains one of Australia\'s most affordable capital city property markets, making it an attractive option for first home buyers and interstate investors seeking better value.',
      'Adelaide\'s northern suburbs — including Mawson Lakes, Gepps Cross, and Prospect — are experiencing renewal and growth, with improved infrastructure and new developments lifting the area\'s appeal.',
      'South Australia offers generous first home buyer incentives including stamp duty concessions and the First Home Owner Grant, which can be combined with Costco Shop Card rewards for additional savings.',
    ]}
    faqs={[
      {
        q: 'How do I earn a Costco Shop Card through the Adelaide warehouse?',
        a: 'Apply for a loan through Manage Your Loans as a Costco Executive Member. When your loan settles, you\'ll receive a Shop Card reward redeemable at the Kilburn warehouse or any Costco location in Australia.',
      },
      {
        q: 'What first home buyer incentives are available in South Australia?',
        a: 'South Australia offers a First Home Owner Grant for new builds, plus stamp duty concessions for eligible buyers. Our brokers can help you navigate these benefits alongside competitive loan rates and your Costco Shop Card reward.',
      },
      {
        q: 'Which Adelaide suburbs are covered by this service?',
        a: 'We serve all Adelaide suburbs including Kilburn, Prospect, Enfield, Blair Athol, Clearview, Northgate, Gepps Cross, Mawson Lakes, Pooraka, Nailsworth, and the wider metropolitan area. Apply online from anywhere in SA.',
      },
      {
        q: 'Can I refinance my Adelaide home loan and still get a Shop Card?',
        a: 'Yes. Refinancing is one of our most popular services. If you\'re a Costco Executive Member and your refinanced loan settles through us, you\'ll be eligible for the Costco Shop Card reward.',
      },
    ]}
    suburbData={{
      suburb: 'Kilburn',
      medianHouse: '$620,000',
      medianUnit: '$350,000',
      daysOnMarket: '22 days',
      rentalYield: '4.3%',
      population: '6,800',
      distanceToCostco: '1 km',
    }}
    surroundingSuburbs={[
      { suburb: 'Prospect', medianHouse: '$680,000', medianUnit: '$380,000', daysOnMarket: '21 days' },
      { suburb: 'Enfield', medianHouse: '$650,000', medianUnit: '$360,000', daysOnMarket: '23 days' },
      { suburb: 'Blair Athol', medianHouse: '$600,000', medianUnit: '$340,000', daysOnMarket: '24 days' },
      { suburb: 'Clearview', medianHouse: '$610,000', medianUnit: '$350,000', daysOnMarket: '22 days' },
      { suburb: 'Northgate', medianHouse: '$630,000', medianUnit: '$360,000', daysOnMarket: '23 days' },
      { suburb: 'Gepps Cross', medianHouse: '$580,000', medianUnit: '$340,000', daysOnMarket: '25 days' },
      { suburb: 'Mawson Lakes', medianHouse: '$650,000', medianUnit: '$400,000', daysOnMarket: '20 days' },
      { suburb: 'Pooraka', medianHouse: '$570,000', medianUnit: '$330,000', daysOnMarket: '24 days' },
      { suburb: 'Nailsworth', medianHouse: '$750,000', medianUnit: '$420,000', daysOnMarket: '19 days' },
    ]}
  />
);

export default Kilburn;
